const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i

export function validateContactInquiryForm(form, msg = {}) {
  const errors = {}
  const name = (form.name || '').trim()
  const email = (form.email || '').trim()
  const website = (form.website || '').trim()
  const message = (form.message || '').trim()

  if (!name) {
    errors.name = msg.nameRequired || 'Please enter your name.'
  }
  if (!email) {
    errors.email = msg.emailRequired || 'Please enter your email address.'
  } else if (!EMAIL_RE.test(email)) {
    errors.email = msg.emailInvalid || 'Please enter a valid email address.'
  }
  if (!website) {
    errors.website = msg.websiteRequired || 'Please enter your website.'
  }
  if (!message) {
    errors.message = msg.messageRequired || 'Please enter your message.'
  }

  return {
    valid: Object.keys(errors).length === 0,
    errors,
    values: { name, email, website, message }
  }
}
